import {
    IResultWithPagination,
    IDataWithPaginationCostRevenue,
} from 'reducers/models';

export interface IExportJobs extends IResultWithPagination<IExportJob> { }
export interface ISalesOrders
    extends IDataWithPaginationCostRevenue<ISalesOrder> { }

export interface INftpBillableResponse {
    jobId: number;
    isNftpBillable: boolean;
}

export interface ISalesOrder {
    lastUpdatedDate: string;
    salesOrderNumber: string;
    finNumber: string;
    finOpsStatus: string;
    triggeredByDocumentNumber: string;
    triggeredByDocumentType: string;
    triggeredByDocumentId: number;
    id: number;
}

export interface IEquipments {
    equipmentId: number;
    equipmentNumber: string;
    status: string;
    sealNumber: string;
    type: string;
    size: number;
    subType: string;
    subSize: string;
    equipmentTotalVolume: string;
    quantity: string;
    weight: string;
    packages: string;
    documentOnEquipmentVolume: string;
    etOnEssoVolumeFactor: string;
    essoOnEtVolumeFactor: string;
    createDate: string;
    updateDate: string;
    primaryIncoterm?: string;
    secondaryIncoterm?: string;
}
export interface IEquipments {
    equipmentId: number;
    equipmentNumber: string;
    status: string;
    sealNumber: string;
    type: string;
    size: number;
    subType: string;
    subSize: string;
    equipmentTotalVolume: string;
    quantity: string;
    weight: string;
    packages: string;
    documentOnEquipmentVolume: string;
    etOnEssoVolumeFactor: string;
    essoOnEtVolumeFactor: string;
    createDate: string;
    updateDate: string;
    primaryIncoterm?: string;
    secondaryIncoterm?: string;
}
export interface IVoyages {
    voyageId: number;
    voyageNumber: string;
    vesselCode: string;
    vesselName: string;
    loadingPortName: string;
    loadingPortCode: string;
    destinationPortName: string;
    destinationPortCode: string;
    eta: string;
    etd: string;
    ata: string;
    atd: string;
    type: string;
}
export interface ITransportPlanLegVoyage {
    voyageId: number;
    voyageNumber: string;
    vesselCode: string;
    vesselName: string;
    vesselType: string;
    legSequence: number;
}
export interface IExportJobDetail {
    isTransferred?: boolean;
    documentId: number;
    primaryDocumentId: number;
    primaryDocumentType: string;
    finNumber: string;
    documentNumber: string;
    originalDocumentNumber: string;
    type: string;
    businessSubCategory: string;
    finOpsStatus: string;
    opsStatus: string;
    rateErrorMessage: string;
    lastSORequestSentAt?: string;
    placeOfReceiptCode: string;
    placeOfReceiptName: string;
    placeOfDeliveryCode: string;
    placeOfDeliveryName: string;
    portOfLoadingCode: string;
    portOfLoadingName: string;
    portOfDischargeCode: string;
    portOfDischargeName: string;
    prepaidCollectIndicator: string;
    pricingSource?: number | string;
    serviceAtOrigin: string;
    serviceAtDestination: string;
    createDate: string;
    lastUpdateDate: string;
    companyCode: string;
    salesArea: string;
    originOffice: string;
    destinationOffice: string;
    salesOrderNumber: string;
    salesDocumentType: string;
    salesDocumentCurrency: string;
    salesDocumentNetValue: number;
    etd: string;
    shipmentType: string;
    consigneeFactCode: string;
    issuerCountryCode: string;
    purchaseOrganisation?: string;
    notificationIndicator?: boolean;
    purchaseOrderNumbers: string[];
    equipments: IEquipments[] | any[];
    voyages: IVoyages[];
    transportPlanLegVoyages?: ITransportPlanLegVoyage[];
    incoTerm: string;
    weight: number;
    contractualParty: string;
    contractualPartyRole: string;
}
export interface IExportDetailsCostAndRevenue {
    bookingSplitId: number;
    bookingId: number;
    bookingNumber: string;
    documentId: number;
    documentNumber: string;
    cblId: number;
    cblNumber: string;
    equipmentId: number;
    equipmentNumber: string;
    containerType: string;
    containerSize: string;
    substitutionType: string;
    quantity: number;
    weight: number;
    volume: number;
    packages: number;
    substitutionSize: string;
}
export interface IExportDetailsClr {
    clrId: number;
    clrNumber: string;
    opsStatus: string;
    quantity: number;
    weight: number;
    volume: number;
    packages: number;
    updateDate: string;
}
export interface IExportDetailsCbl {
    id: number;
    number: string;
    bookingNumber: string;
    status: string;
    carriercontract: string;
    carrier: string;
    carrierCode?: string;
    shippername: string;
    portOfLoadingName?: string;
    placeOfReceiptName: string;
    portOfDischargeName?: string;
    cargoReadyDate?: string;
    quantity: number;
    weight: number;
    volume: number;
    packages: number;
    consigneeName: string;
    carrierbookingreference: string;
    essocblonetvolumefactor: number;
    essoetoncblvolumefactor: number;
    placeOfDeliveryCode: string;
    placeOfDeliveryName: string;
    transportContractNumber?: string;
    internalShipmentNumber?: string;
    updatedDateTime: string;
    createdDateTime: string;
}

export interface IExportDetailsBookingAndCargo {
    bookings: IExportDetailsBooking[];
    totalQuantity: number;
    totalWeight: number;
    totalVolume: number;
    totalPackages: number;
    isInvoiceSplitRequired?: boolean; // header-level flag of the bookings response; drives the AnyBookingFlag trigger
}

/** Equipment connected to a booking, with the lane ids from its CLRs. */
export interface IExportBookingEquipment {
    equipmentNumber: string;
    laneIds: string[];
}

export interface IExportDetailsBooking {
    id: number;
    number: string;
    bookingNumber: string;
    laneId?: string | null;
    pickupLocation?: string | null;
    primaryIncoterm?: string | null;
    secondaryIncoterm?: string | null;
    equipments?: IExportBookingEquipment[];
    status: string;
    portOfLoadingName?: string;
    placeOfReceiptName: string;
    portOfDischargeName?: string;
    cargoReadyDate?: string;
    quantity: number;
    weight: number;
    volume: number;
    packages: number;
    serviceAtOrigin: string;
    serviceAtDestination: string;
    bookingAgent?: string;
    cargoType: string;
    consigneeCountryCode: string;
    consigneeBusinessEntityCode: string;
    consigneeName: string;
    consigneeFactCode: string;
    consigneeSCVCode: string;
    destinationSiteCode?: string;
    destinationSiteName?: string;
    originSiteName: string;
    originSiteCode: string;
    placeOfDeliveryCode: string;
    placeOfDeliveryName: string;
    ultimatePlaceOfDeliveryCode: string;
    ultimatePlaceOfDeliveryName: string;
    paymentType?: string;
    internalShipmentNumber?: string;
    shipmentId: number;
    updatedDateTime: string;
    officeCode: string;
    incoTerms: string;
    isTransferred?: any;
    createdDateTime: string;
    specialCargoIndicator: string;
    originServiceSubType?: string | null;
    remarks?: string | null;
    serviceLevel?: string | null;
    serviceLoadType?: string | null;
}

export interface IExportDetailsEts {
    id: number;
    equipmentTransportShipmentDocumentNumber: string;
    equipmentNumber: string;
    equipmentSealNumber: string;
    shipmentNumber: string;
    volume: number;
    createDate: string;
    lastUpdateDate: string;
    isCancelled: boolean;
    anyIssoSent: boolean;
    quantity: number;
    packages: number;
    weight: number;
}

export interface IExportDetailsCustomerInvoice {
    billToParty: string;
    billingCurrency: string;
    billingDate: string;
    billingType: string;
    createdBy: string;
    createdDate: string;
    internalBillingNumber: string;
    invoiceDueDate: string;
    invoiceStatus: string;
    invoicesId: number;
    sapBillingNumber: string;
    totalAmount: number;
}

export const EmptyExportDetailsBookingAndCargo: IExportDetailsBookingAndCargo =
{
    bookings: [],
    totalQuantity: 0,
    totalWeight: 0,
    totalVolume: 0,
    totalPackages: 0,
};

export interface IExportJob {
    exportJobNumber: number;
    productType: string;
    exportJobStatus: string;
    primaryDocumentNumber: string;
    exportJobId: number;
    primaryDocumentStatus: string;
    cblNumber?: string;
    sapSalesOrderNumber: string;
    origin: string;
    destination: string;
    consignee: string;
    rateErrorMessage: string;
    lastChangedBy: string;
    estimatedTimeOfArrival: string;
    estimatedTimeOfDeparture: string;
    lastChangeDate: string;
    shipper: string;
}

export const EmptyDocumentDetail: IExportJobDetail = {
    primaryDocumentId: 0,
    primaryDocumentType: '',
    documentId: 0,
    documentNumber: '',
    finNumber: '',
    originalDocumentNumber: '',
    rateErrorMessage: '',
    type: '',
    finOpsStatus: '',
    opsStatus: '',
    shipmentType: '',
    placeOfReceiptCode: '',
    placeOfReceiptName: '',
    placeOfDeliveryCode: '',
    placeOfDeliveryName: '',
    portOfLoadingCode: '',
    portOfLoadingName: '',
    portOfDischargeCode: '',
    portOfDischargeName: '',
    prepaidCollectIndicator: '',
    serviceAtOrigin: '',
    serviceAtDestination: '',
    createDate: '',
    lastUpdateDate: '',
    companyCode: '',
    salesArea: '',
    salesDocumentCurrency: '',
    salesDocumentNetValue: 0,
    salesDocumentType: '',
    salesOrderNumber: '',
    originOffice: '',
    destinationOffice: '',
    equipments: [],
    purchaseOrderNumbers: [],
    voyages: [],
    etd: '',
    consigneeFactCode: '',
    issuerCountryCode: '',
    businessSubCategory: '',
    incoTerm: '',
    weight: 0,
    contractualParty: '',
    contractualPartyRole: '',
};

export interface IExportDetailsForRevenueItem {
    exportJobId: number;
    essoRateDetailId: number;
    exportJobNumber: string;
    salesOrderItem: string;
    status: string;
    billToPartyCode: string;
    billToPartyName: string;
    iCB: string;
    quantity: number;
    rOE: string;
    errorReason: string;
    pricingDate: string;
    billingDate: string;
}

export interface IExportDetailsForCostItem {
    exportJobId: number;
    essoRateDetailId: number;
    exportJobNumber: string;
    salesOrderItem: string;
    status: string;
    billToPartyCode: string;
    billToPartyName: string;
    iCB: string;
    quantity: number;
    rOE: string;
    errorReason: string;
    contractNumberItem: string;
    infoRecord: string;
    pricingDate: string;
    tax: number;
}

export interface IEquipmentDetailsForExportJob {
    equipmentNumber: string;
    containerSizeType: string;
    substitutionSizeType: string;
    quantity: number;
    bookingNumber: string;
    documentNumber: string;
}
